import React from "react";

/**
 * Reusable Decorative Grid Lines Component - Variant 2
 *
 * Structure:
 * - 6 horizontal rows total: 5 main upper rows + 1 short bottom row
 * - 12 columns per row (Half width cell on col 1 and col 12)
 * - Row 1: Vertical lines at index 3, 4, 5, and 6 are empty (hidden)
 * - Row 2 & 3: Vertical lines at index 3 and 5 are empty (hidden)
 * - Row 4, 5 & 6: Grid lines
 *
 * @param {string} variant - Optional layout variant name
 * @param {string} label - Optional target node label
 */
const DecorativeLines2 = ({ variant = "default", label = "" }) => {
    const rows = [1, 2, 3, 4, 5, 6];
    const cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    /**
     * Determines if the vertical right border of column `colIndex` should be omitted
     */
    const isVerticalLineHidden = (rowIndex, colIndex) => {
        if (rowIndex === 1) {
            // Row 1: vertical lines 3-5 and 6 are empty
            return (
                (colIndex >= 2 && colIndex <= 4) ||
                colIndex === 6 ||
                colIndex === 10
            );
        }
        if (rowIndex === 2 || rowIndex === 3 || rowIndex === 4) {
            // Row 2, 3 & 4: vertical line di box 2 (colIndex 2) dihilangkan
            return colIndex === 2;
        }
        return false;
    };

    /**
     * Determines if the horizontal bottom border of row `rowIndex` should be omitted
     */
    const isBottomLineHidden = (rowIndex, colIndex) => {
        // Row 2: garis horizontal di bawah dihapus untuk colIndex 2 & 3
        if (rowIndex === 2) {
            if (colIndex === 2 || colIndex === 3) {
                return true;
            }
        }
        return false;
    };

    return (
        <div className={`DecorativeLines2 DecorativeLines2--${variant}`}>
            <div className="DecorativeLines2__grid">
                {rows.map((rowIndex) => (
                    <div
                        key={`row-${rowIndex}`}
                        className={`DecorativeLines2__row DecorativeLines2__row--${rowIndex}`}
                    >
                        {cols.map((colIndex) => {
                            const hideRightBorder = isVerticalLineHidden(
                                rowIndex,
                                colIndex,
                            );
                            const hideBottomBorder = isBottomLineHidden(
                                rowIndex,
                                colIndex,
                            );
                            const isHalfCol = colIndex === 1 || colIndex === 12;
                            return (
                                <div
                                    key={`cell-${rowIndex}-${colIndex}`}
                                    className={`DecorativeLines2__cell ${
                                        isHalfCol
                                            ? "DecorativeLines2__cell--half"
                                            : ""
                                    } ${
                                        hideRightBorder
                                            ? "DecorativeLines2__cell--no-v-line"
                                            : ""
                                    } ${
                                        hideBottomBorder
                                            ? "DecorativeLines2__cell--no-h-line"
                                            : ""
                                    }`}
                                />
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DecorativeLines2;
